import { useSoftKeyboardOpen } from "@/lib/useSoftKeyboardOpen";

// Persistent bottom action bar for the FLOOR (tablet) surface.
//
// USE THIS instead of a raw `fixed bottom-0` <div> for ANY persistent bottom bar on the
// floor. On tablets the on-screen keyboard pushes a fixed bottom bar ON TOP of the input or
// submit the operator is using — in landscape it can shove the control off-screen entirely
// (this is exactly what made lot notes un-addable on a Samsung tablet, 2026-06). This
// wrapper hides the bar whenever a text field is focused, so it can never occlude a control,
// and restores it the moment focus leaves the field.
//
// RULE (do not break): always keep a NON-bottom-fixed exit available while the bar is
// hidden — e.g. the header "← Floor" button (data-testid floor-return-top) — so hiding the
// bar can never strand the operator mid-task.
export function KeyboardAwareBottomBar({ children, className = "", testid, ...rest }) {
  const kbOpen = useSoftKeyboardOpen();
  if (kbOpen) return null;
  return (
    <div data-testid={testid} className={`fixed bottom-0 inset-x-0 z-50 print:hidden ${className}`} {...rest}>
      {children}
    </div>
  );
}
